<template>
    <div class="libraryList" v-if="goodsList">
        <div class="libraryBox" v-for="(item,index) in goodsList" :key="item.id" @click="goodsTap(item.id)">
            <el-image :src="item.goods_img" fit="cover" lazy class="libraryImg" />
            <div class="libraryTitle">{{ item.goods_name }}</div>
            <div class="librarySpb">
                <div class="libraryPrice"><span>￥</span>{{ item.price }}</div>
                <div class="libraryNum">{{ item.sales }}人已用</div>
            </div>
            <div class="libraryProfit">
                <div class="align">
                    <div class="profitIcon">赚</div>
                    <div class="profitPrice"><span>￥</span>{{ item.yugu }}</div>
                </div>
                <div class="directional">定向高佣{{ item.commission }}%</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        },
        props:{
			goodsList: {
				type: Array,
				default: () => []
			},
		},
        methods: {
             // 跳转商品详情
             goodsTap(e){
                this.$router.push({ path:'/goods/detail', query:{id:e} })
            },
        }
    }
</script>
<style lang="less" scoped>
    .libraryList{
        width: 1164px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 4px;
        overflow-y: scroll;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        .libraryBox{
            width: 220px;
            height: 353px;
            background: #FEFEFE;
            border: 1px solid #FDE4D4;
            box-shadow: 0px 0px 27px 0px rgba(124,124,124,0.11);
            border-radius: 8px;
            margin: 14px 13.5px 0 0;
            overflow: hidden;
            cursor: pointer;
            &:nth-child(5n){
                margin-right: 0;
            }
            .libraryImg{
                width: 220px;
                height: 224px;
            }
            .libraryTitle{
                height: 44px;
                margin: 6px 9px;
                font: 14px/22px "Microsoft YaHei";
                color: #3E3E3E;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .librarySpb{
                margin-top: 15px;
                padding: 0 9px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .libraryPrice{
                    font: 14px/14px "Microsoft YaHei";
                    color: #333;
                    span{
                        font: 12px/14px "Microsoft YaHei";
                    }
                }
                .libraryNum{
                    font: 12px/12px "Microsoft YaHei";
                    color: #A4A4A4;
                }
            }
            .libraryProfit{
                padding: 10px 9px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .profitIcon{
                    width: 22px;
                    height: 24px;
                    background: #FFF5EE;
                    border-radius: 5px;
                    font: 14px/24px "Microsoft YaHei";
                    color: #FF6A00;
                    text-align: center;
                }
                .profitPrice{
                    padding-left: 4px;
                    font: 18px/18px "Microsoft YaHei";
                    color: #FF7221;
                    span{
                        font: 12px/18px "Microsoft YaHei";
                    }
                }
                .directional{
                    height: 24px;
                    background: #FFF5EE;
                    border-radius: 5px;
                    padding: 0 8px;
                    font: 12px/24px "Microsoft YaHei";
                    color: #FF6A00;
                }
            }
        }
    }
</style>